import { InfoCircleOutlined } from '@ant-design/icons';
import { Col, Collapse, Empty, Grid, Row, Space, Spin, Tooltip } from 'antd';
import React, { Fragment, useContext } from 'react';
import { SubSubtitleStart } from '../../components';
import LabelValidateMessage from '../../components/LabelValidateMessage';
import LogoYTexto from '../../components/LogoYTexto';
import UserContext from '../../context/user-context';
import PlanSelector from './PlanSelector';

const { useBreakpoint } = Grid;
const { Panel } = Collapse;

function PanelHeader(props) {
  const { comision } = props;
  return (
    <Row justify="start" align="middle">
      <Col
        style={{
          textAlign: 'start',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          width: '100%',
          paddingLeft: 20,
          paddingRight: 20
        }}
      >
        Rango Comisión - {comision.valor}%
      </Col>
    </Row>
  );
}

const tieneComision = (comision, planes) => {
  return (
    planes.filter((e) => e.comisionAseguradora.id === comision.id).length > 0
  );
};
const verificarComisionUnica = (cotizaciones) => {
  // Iteramos sobre cada cotización
  for (const cotizacion of cotizaciones) {
    const comisionUnica = cotizacion.planes[0].comisionAseguradora.valor;
    // Iteramos sobre cada plan de la cotización
    for (const plan of cotizacion.planes) {
      // eslint-disable-next-line no-lonely-if
      if (plan.comisionAseguradora.valor !== comisionUnica) {
        return false;
      }
    }
  }

  // Si no encontramos ninguna diferencia, retornamos true
  return true;
};

const SelectorPlanes = ({
  cotizacion,
  moneda,
  getSelected,
  onChange,
  opcionesDePago,
  disabled,
  subcoberturasParaExcluir,
  controlFranquicias,
  alertaParaEjecutivo,
  comisionAseguradoraList,
  unaComision
}) => {
  // eslint-disable-next-line react/destructuring-assignment
  const planesEstandares = cotizacion.planes.filter(
    (item) => item.id_plan && moneda && item.id_moneda === moneda.id
  );
  // eslint-disable-next-line react/destructuring-assignment
  const planesEspecificos = cotizacion.planes.filter(
    (item) => !item.id_plan && moneda && item.id_moneda === moneda.id
  );

  return (
    <>
      {planesEspecificos.length === 0 && planesEstandares.length === 0 && (
        <span>Sin planes en {(moneda && moneda.descripcion) || ''}</span>
      )}

      {planesEstandares.length > 0 && (
        <>
          <SubSubtitleStart level={4}>Planes Estándar</SubSubtitleStart>
          {!unaComision ? (
            comisionAseguradoraList.map(
              (comision) =>
                tieneComision(comision, planesEstandares) && (
                  <Collapse expandIconPosition="end">
                    <Panel
                      header={<PanelHeader comision={comision} />}
                      key={`planEstandar${comision.id}`}
                      style={{ marginBottom: '2%' }}
                    >
                      <div style={{ display: 'inline-block' }}>
                        <PlanSelector
                          // eslint-disable-next-line react/destructuring-assignment
                          selected={getSelected(
                            cotizacion.id,
                            'estandar',
                            moneda,
                            comision.id
                          )}
                          onChange={(column) =>
                            onChange &&
                            onChange(
                              cotizacion.id,
                              'estandar',
                              column,
                              moneda,
                              comision.id
                            )
                          }
                          planes={planesEstandares.filter(
                            (e) => e.comisionAseguradora.id === comision.id
                          )}
                          hover={!disabled}
                          multiple
                          mostrarTipo
                          opcionesDePago={opcionesDePago}
                          moneda={moneda}
                          infoMoneda
                          disabled={disabled}
                          subcoberturasParaExcluir={subcoberturasParaExcluir}
                          controlFranquicias={controlFranquicias}
                          alertaParaEjecutivo={alertaParaEjecutivo}
                        />{' '}
                      </div>
                    </Panel>
                  </Collapse>
                )
            )
          ) : (
            <div style={{ display: 'inline-block' }}>
              <PlanSelector
                // eslint-disable-next-line react/destructuring-assignment
                selected={getSelected(
                  cotizacion.id,
                  'estandar',
                  moneda,
                  planesEstandares[0].comisionAseguradora.id
                )}
                onChange={(column) =>
                  onChange &&
                  onChange(
                    cotizacion.id,
                    'estandar',
                    column,
                    moneda,
                    planesEstandares[0].comisionAseguradora.id
                  )
                }
                planes={planesEstandares}
                hover={!disabled}
                multiple
                mostrarTipo
                opcionesDePago={opcionesDePago}
                moneda={moneda}
                infoMoneda
                disabled={disabled}
                subcoberturasParaExcluir={subcoberturasParaExcluir}
                controlFranquicias={controlFranquicias}
                alertaParaEjecutivo={alertaParaEjecutivo}
              />{' '}
            </div>
          )}
        </>
      )}
      {planesEspecificos.length > 0 && (
        <>
          <SubSubtitleStart level={4}>Planes Específicos</SubSubtitleStart>
          {!unaComision ? (
            comisionAseguradoraList.map(
              (comision) =>
                tieneComision(comision, planesEspecificos) && (
                  <Collapse expandIconPosition="end">
                    <Panel
                      header={<PanelHeader comision={comision} />}
                      key={`planEspecifico${comision.id}`}
                      style={{ marginBottom: '2%' }}
                    >
                      {' '}
                      <div style={{ display: 'inline-block' }}>
                        <PlanSelector
                          // eslint-disable-next-line react/destructuring-assignment
                          selected={getSelected(
                            cotizacion.id,
                            'especifico',
                            moneda,
                            comision.id
                          )}
                          onChange={(column) =>
                            onChange &&
                            onChange(
                              cotizacion.id,
                              'especifico',
                              column,
                              moneda,
                              comision.id
                            )
                          }
                          planes={planesEspecificos.filter(
                            (e) => e.comisionAseguradora.id === comision.id
                          )}
                          hover={!disabled}
                          multiple
                          mostrarTipo
                          opcionesDePago={opcionesDePago}
                          moneda={moneda}
                          infoMoneda
                          disabled={disabled}
                          subcoberturasParaExcluir={subcoberturasParaExcluir}
                          controlFranquicias={controlFranquicias}
                          alertaParaEjecutivo={alertaParaEjecutivo}
                          comision={comision}
                        />
                      </div>
                    </Panel>
                  </Collapse>
                )
            )
          ) : (
            <div style={{ display: 'inline-block' }}>
              <PlanSelector
                // eslint-disable-next-line react/destructuring-assignment
                selected={getSelected(
                  cotizacion.id,
                  'especifico',
                  moneda,
                  planesEspecificos[0].comisionAseguradora.id
                )}
                onChange={(column) =>
                  onChange &&
                  onChange(
                    cotizacion.id,
                    'especifico',
                    column,
                    moneda,
                    planesEspecificos[0].comisionAseguradora.id
                  )
                }
                planes={planesEspecificos}
                hover={!disabled}
                multiple
                mostrarTipo
                opcionesDePago={opcionesDePago}
                moneda={moneda}
                infoMoneda
                disabled={disabled}
                subcoberturasParaExcluir={subcoberturasParaExcluir}
                controlFranquicias={controlFranquicias}
                alertaParaEjecutivo={alertaParaEjecutivo}
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

const SelectorPlanesMobile = ({
  cotizacion,
  moneda,
  getSelected,
  onChange,
  opcionesDePago,
  disabled,
  subcoberturasParaExcluir,
  controlFranquicias,
  alertaParaEjecutivo,
  comisionAseguradoraList,
  unaComision
}) => {
  const planesEstandares = cotizacion.planes.filter(
    (item) => item.id_plan && moneda && item.id_moneda === moneda.id
  );
  const planesEspecificos = cotizacion.planes.filter(
    (item) => !item.id_plan && moneda && item.id_moneda === moneda.id
  );

  return (
    <Space
      direction="vertical"
      align="start"
      style={{
        display: 'grid'
      }}
    >
      {planesEspecificos.length === 0 && planesEstandares.length === 0 && (
        <span>Sin planes en {(moneda && moneda.descripcion) || ''}</span>
      )}
      {planesEstandares.length > 0 && !unaComision ? (
        comisionAseguradoraList.map(
          (comision) =>
            tieneComision(comision, planesEspecificos) && (
              <Collapse expandIconPosition="end" style={{ width: '100%' }}>
                <Panel
                  header={<PanelHeader comision={comision} />}
                  key={`planEspecifico${comision.id}`}
                  style={{ width: '100%', marginBottom: '2%' }}
                >
                  <div style={{ display: 'grid' }}>
                    <PlanSelector
                      selected={getSelected(
                        cotizacion.id,
                        'estandar',
                        moneda,
                        comision.id
                      )}
                      onChange={(column) =>
                        onChange &&
                        onChange(
                          cotizacion.id,
                          'estandar',
                          column,
                          moneda,
                          comision.id
                        )
                      }
                      planes={planesEstandares.filter(
                        (e) => e.comisionAseguradora.id === comision.id
                      )}
                      hover={!disabled}
                      multiple
                      mostrarTipo
                      tituloAdicional="Detalle de Coberturas - Estándar"
                      opcionesDePago={opcionesDePago}
                      moneda={moneda}
                      infoMoneda
                      disabled={disabled}
                      subcoberturasParaExcluir={subcoberturasParaExcluir}
                      controlFranquicias={controlFranquicias}
                      alertaParaEjecutivo={alertaParaEjecutivo}
                      comision={comision}
                    />
                  </div>{' '}
                </Panel>
              </Collapse>
            )
        )
      ) : (
        <div style={{ display: 'grid' }}>
          <PlanSelector
            selected={getSelected(
              cotizacion.id,
              'estandar',
              moneda,
              planesEstandares[0].comisionAseguradora.id
            )}
            onChange={(column) =>
              onChange &&
              onChange(
                cotizacion.id,
                'estandar',
                column,
                moneda,
                planesEstandares[0].comisionAseguradora.id
              )
            }
            planes={planesEstandares}
            hover={!disabled}
            multiple
            mostrarTipo
            tituloAdicional="Detalle de Coberturas - Estándar"
            opcionesDePago={opcionesDePago}
            moneda={moneda}
            infoMoneda
            disabled={disabled}
            subcoberturasParaExcluir={subcoberturasParaExcluir}
            controlFranquicias={controlFranquicias}
            alertaParaEjecutivo={alertaParaEjecutivo}
          />
        </div>
      )}
      {planesEspecificos.length > 0 && !unaComision ? (
        comisionAseguradoraList.map(
          (comision) =>
            tieneComision(comision, planesEspecificos) && (
              <Collapse expandIconPosition="end" style={{ width: '100%' }}>
                <Panel
                  header={<PanelHeader comision={comision} />}
                  key={`planEspecifico${comision.id}`}
                  style={{ width: '100%', marginBottom: '2%' }}
                >
                  <div style={{ display: 'grid' }}>
                    <PlanSelector
                      selected={getSelected(
                        cotizacion.id,
                        'especifico',
                        moneda,
                        comision.id
                      )}
                      onChange={(column) =>
                        onChange &&
                        onChange(
                          cotizacion.id,
                          'especifico',
                          column,
                          moneda,
                          comision.id
                        )
                      }
                      planes={planesEspecificos.filter(
                        (e) => e.comisionAseguradora.id === comision.id
                      )}
                      hover={!disabled}
                      multiple
                      mostrarTipo
                      tituloAdicional="Detalle de Coberturas - Específico"
                      opcionesDePago={opcionesDePago}
                      moneda={moneda}
                      infoMoneda
                      disabled={disabled}
                      subcoberturasParaExcluir={subcoberturasParaExcluir}
                      controlFranquicias={controlFranquicias}
                      alertaParaEjecutivo={alertaParaEjecutivo}
                      comision={comision}
                    />
                  </div>{' '}
                </Panel>
              </Collapse>
            )
        )
      ) : (
        <div style={{ display: 'grid' }}>
          <PlanSelector
            selected={getSelected(
              cotizacion.id,
              'especifico',
              moneda,
              planesEspecificos[0].comisionAseguradora.id
            )}
            onChange={(column) =>
              onChange &&
              onChange(
                cotizacion.id,
                'especifico',
                column,
                moneda,
                planesEspecificos[0].comisionAseguradora.id
              )
            }
            planes={planesEspecificos}
            hover={!disabled}
            multiple
            mostrarTipo
            tituloAdicional="Detalle de Coberturas - Específico"
            opcionesDePago={opcionesDePago}
            moneda={moneda}
            infoMoneda
            disabled={disabled}
            subcoberturasParaExcluir={subcoberturasParaExcluir}
            controlFranquicias={controlFranquicias}
            alertaParaEjecutivo={alertaParaEjecutivo}
          />
        </div>
      )}
    </Space>
  );
};

const SelectorPlanesCliente = ({
  cotizacion,
  moneda,
  getSelectedCliente,
  onChange,
  opcionesDePago,
  disabled,
  subcoberturasParaExcluir,
  controlFranquicias,
  alertaParaEjecutivo,
  comisionesAEPList
}) => {
  // eslint-disable-next-line react/destructuring-assignment
  let planesEstandares = cotizacion.planes.filter(
    (item) => item.id_plan && moneda && item.id_moneda === moneda.id
  );
  // eslint-disable-next-line react/destructuring-assignment
  let planesEspecificos = cotizacion.planes.filter(
    (item) => !item.id_plan && moneda && item.id_moneda === moneda.id
  );

  const comisionEstandaresCliente = comisionesAEPList.find(
    (item) => item.tipo === 'estandar'
  );
  const comisionEspecificosCliente = comisionesAEPList.find(
    (item) => item.tipo === 'especifico'
  );

  planesEstandares = planesEstandares.filter(
    (item) =>
      item?.id_aseguradora_empresa_producto ===
        comisionEstandaresCliente?.id_aseguradora_empresa_producto &&
      item.id_comision_aseguradora ===
        comisionEstandaresCliente?.id_comision_aseguradora
  );
  planesEspecificos = planesEspecificos.filter(
    (item) =>
      item?.id_aseguradora_empresa_producto ===
        comisionEspecificosCliente?.id_aseguradora_empresa_producto &&
      item.id_comision_aseguradora ===
        comisionEspecificosCliente?.id_comision_aseguradora
  );

  return (
    <Space direction="vertical" align="start" style={{ display: 'flex' }}>
      {planesEspecificos.length === 0 && planesEstandares.length === 0 && (
        <span>Sin planes en {(moneda && moneda.descripcion) || ''}</span>
      )}
      {planesEstandares.length > 0 && (
        <>
          <SubSubtitleStart level={4}>Planes Estándar</SubSubtitleStart>
          <PlanSelector
            // eslint-disable-next-line react/destructuring-assignment
            selected={getSelectedCliente(cotizacion.id, 'estandar', moneda)}
            onChange={(column) =>
              onChange && onChange(cotizacion.id, 'estandar', column, moneda)
            }
            planes={planesEstandares}
            hover={!disabled}
            multiple
            mostrarTipo
            opcionesDePago={opcionesDePago}
            moneda={moneda}
            infoMoneda
            disabled={disabled}
            subcoberturasParaExcluir={subcoberturasParaExcluir}
            controlFranquicias={controlFranquicias}
            alertaParaEjecutivo={alertaParaEjecutivo}
          />
        </>
      )}
      {planesEspecificos.length > 0 && (
        <>
          <SubSubtitleStart level={4}>Planes Específicos</SubSubtitleStart>

          <PlanSelector
            // eslint-disable-next-line react/destructuring-assignment
            selected={getSelectedCliente(cotizacion.id, 'especifico', moneda)}
            onChange={(column) =>
              onChange && onChange(cotizacion.id, 'especifico', column, moneda)
            }
            planes={planesEspecificos}
            hover={!disabled}
            multiple
            mostrarTipo
            opcionesDePago={opcionesDePago}
            moneda={moneda}
            infoMoneda
            disabled={disabled}
            subcoberturasParaExcluir={subcoberturasParaExcluir}
            controlFranquicias={controlFranquicias}
            alertaParaEjecutivo={alertaParaEjecutivo}
          />
        </>
      )}
    </Space>
  );
};

const SelectorPlanesMobileCliente = ({
  cotizacion,
  moneda,
  getSelectedCliente,
  onChange,
  opcionesDePago,
  disabled,
  subcoberturasParaExcluir,
  controlFranquicias,
  alertaParaEjecutivo,
  comisionesAEPList
}) => {
  let planesEstandares = cotizacion.planes.filter(
    (item) => item.id_plan && moneda && item.id_moneda === moneda.id
  );
  let planesEspecificos = cotizacion.planes.filter(
    (item) => !item.id_plan && moneda && item.id_moneda === moneda.id
  );

  const comisionEstandaresCliente = comisionesAEPList.find(
    (item) => item.tipo === 'estandar'
  );
  const comisionEspecificosCliente = comisionesAEPList.find(
    (item) => item.tipo === 'especifico'
  );

  planesEstandares = planesEstandares.filter(
    (item) =>
      item?.id_aseguradora_empresa_producto ===
        comisionEstandaresCliente?.id_aseguradora_empresa_producto &&
      item.id_comision_aseguradora ===
        comisionEstandaresCliente?.id_comision_aseguradora
  );
  planesEspecificos = planesEspecificos.filter(
    (item) =>
      item?.id_aseguradora_empresa_producto ===
        comisionEspecificosCliente?.id_aseguradora_empresa_producto &&
      item.id_comision_aseguradora ===
        comisionEspecificosCliente?.id_comision_aseguradora
  );
  return (
    <Space
      direction="vertical"
      align="start"
      style={{
        display: 'grid'
      }}
    >
      {planesEspecificos.length === 0 && planesEstandares.length === 0 && (
        <span>Sin planes en {(moneda && moneda.descripcion) || ''}</span>
      )}
      {planesEstandares.length > 0 && (
        <div style={{ display: 'grid' }}>
          <PlanSelector
            selected={getSelectedCliente(cotizacion.id, 'estandar', moneda)}
            onChange={(column) =>
              onChange && onChange(cotizacion.id, 'estandar', column, moneda)
            }
            planes={planesEstandares}
            hover={!disabled}
            multiple
            mostrarTipo
            tituloAdicional="Detalle de Coberturas - Estándar"
            opcionesDePago={opcionesDePago}
            moneda={moneda}
            infoMoneda
            disabled={disabled}
            subcoberturasParaExcluir={subcoberturasParaExcluir}
            controlFranquicias={controlFranquicias}
            alertaParaEjecutivo={alertaParaEjecutivo}
          />
        </div>
      )}
      {planesEspecificos.length > 0 && (
        <div style={{ display: 'grid' }}>
          <PlanSelector
            selected={getSelectedCliente(cotizacion.id, 'especifico', moneda)}
            onChange={(column) =>
              onChange && onChange(cotizacion.id, 'especifico', column, moneda)
            }
            planes={planesEspecificos}
            hover={!disabled}
            multiple
            mostrarTipo
            tituloAdicional="Detalle de Coberturas - Específico"
            opcionesDePago={opcionesDePago}
            moneda={moneda}
            infoMoneda
            disabled={disabled}
            subcoberturasParaExcluir={subcoberturasParaExcluir}
            controlFranquicias={controlFranquicias}
            alertaParaEjecutivo={alertaParaEjecutivo}
          />
        </div>
      )}
    </Space>
  );
};

const GroupPlanSelectorMultiple = ({
  selected,
  onChange,
  cotizaciones,
  opcionesDePago,
  monedaSelectedList,
  validacionByAseguradoraList,
  mostrarValidaciones,
  loading = false,
  subcoberturasParaExcluir,
  controlFranquicias,
  alertaParaEjecutivo,
  comisionAseguradoraList,
  comisionesAEPList
}) => {
  const screens = useBreakpoint();
  const { user } = useContext(UserContext);
  const gruposDelUsuario = user['cognito:groups'];

  const esCliente = gruposDelUsuario[0] === 'CLIENTE';

  const getSelected = (idCotizacion, tipo, moneda, idComision) => {
    if (idComision) {
      // [[0,0], [0,1]] [[idComision, indiceColumna]]
      const selectedIndexs = selected[tipo]?.[idCotizacion]?.[moneda.codigo];
      // Se filtra por el id de comision
      const columnasPorComision = selectedIndexs?.filter(
        (item) => item[0] === idComision
      );
      // El segundo valor de cada elemento es la columna seleccionada.
      // [0,1]
      const columnas = columnasPorComision?.map((item) => item[1]);

      return columnas || [];
    }
    return selected[tipo]?.[idCotizacion]?.[moneda.codigo] || [];
  };

  const getSelectedCliente = (idCotizacion, tipo, moneda) => {
    return selected[tipo]?.[idCotizacion]?.[moneda.codigo] || [];
  };

  const unaComision = verificarComisionUnica(cotizaciones);

  return (
    <div
      style={{
        minHeight: 50,
        overflowX: 'auto'
        // display: `${screens && screens.md === true && 'inline-block'}`
      }}
    >
      <Spin tip="Cargando datos..." spinning={loading} delay={500} size="large">
        {monedaSelectedList &&
        monedaSelectedList.length > 0 &&
        cotizaciones &&
        cotizaciones.length > 0 ? (
          cotizaciones.map((cotizacion, index) => {
            return (
              <Fragment key={index} style={{ width: '100%' }}>
                {screens && screens.md === true && (
                  <Fragment style={{ width: '100%' }}>
                    {cotizacion.planes && cotizacion.planes.length > 0 && (
                      <Fragment
                        style={{
                          textAlign: 'left'
                        }}
                      >
                        <div
                          key={cotizacion.id}
                          style={{
                            textAlign: 'left'
                          }}
                        >
                          <LogoYTexto
                            logo={`/images/aseguradoras/${cotizacion.aseguradoraEmpresa.aseguradora.codigo}.png`}
                            texto={
                              cotizacion.aseguradoraEmpresa.aseguradora.nombre
                            }
                          />
                          <br />
                          {mostrarValidaciones && (
                            <>
                              {validacionByAseguradoraList.find(
                                (item) =>
                                  item.idAseguradora ===
                                    cotizacion.aseguradoraEmpresa.aseguradora
                                      .id && item.mostrarAlerta
                              ) ? (
                                <Space style={{ paddingBottom: 4 }}>
                                  <div style={{ textAlign: 'start' }}>
                                    <LabelValidateMessage
                                      message={
                                        validacionByAseguradoraList.find(
                                          (item) =>
                                            item.idAseguradora ===
                                            cotizacion.aseguradoraEmpresa
                                              .aseguradora.id
                                        ).mensaje
                                      }
                                      type="warning"
                                      hidden
                                    />
                                  </div>
                                  <div style={{ textAlign: 'start' }}>
                                    <Tooltip title="Los datos ingresados se encuentran fuera del rango permitido para esta Aseguradora. Por este motivo la solicitud quedará sujeta a autorización">
                                      <InfoCircleOutlined
                                        style={{ color: 'rgba(0,0,0,.45)' }}
                                      />
                                    </Tooltip>
                                  </div>
                                </Space>
                              ) : (
                                <Space style={{ paddingBottom: 4 }}>
                                  <div style={{ textAlign: 'start' }}>
                                    <LabelValidateMessage
                                      message={
                                        validacionByAseguradoraList.find(
                                          (item) =>
                                            item.idAseguradora ===
                                            cotizacion.aseguradoraEmpresa
                                              .aseguradora.id
                                        )?.mensaje
                                      }
                                      type="secondary"
                                      hidden
                                    />
                                  </div>
                                </Space>
                              )}
                            </>
                          )}
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            maxWidth: '100%'
                          }}
                        >
                          <div key={cotizacion.id} style={{ width: '100%' }}>
                            <Space
                              direction="vertical"
                              align="start"
                              style={{ display: 'flex' }}
                            >
                              {(() => {
                                return (
                                  <>
                                    {monedaSelectedList.map((moneda) => {
                                      return (
                                        <Fragment key={moneda.id}>
                                          {esCliente ? (
                                            <SelectorPlanesCliente
                                              {...{
                                                cotizacion,
                                                moneda,
                                                getSelectedCliente,
                                                onChange,
                                                opcionesDePago
                                              }}
                                              disabled={
                                                validacionByAseguradoraList.find(
                                                  (item) =>
                                                    item.idAseguradora ===
                                                    cotizacion
                                                      .aseguradoraEmpresa
                                                      .aseguradora.id
                                                )?.bloquearPlanes
                                              }
                                              subcoberturasParaExcluir={
                                                subcoberturasParaExcluir
                                              }
                                              controlFranquicias={
                                                controlFranquicias
                                              }
                                              alertaParaEjecutivo={
                                                alertaParaEjecutivo
                                              }
                                              comisionesAEPList={comisionesAEPList.filter(
                                                (item) =>
                                                  item.id_aseguradora_empresa_producto ===
                                                  cotizacion.id_aseguradora_empresa_producto
                                              )}
                                            />
                                          ) : (
                                            <SelectorPlanes
                                              {...{
                                                cotizacion,
                                                moneda,
                                                getSelected,
                                                onChange,
                                                opcionesDePago
                                              }}
                                              disabled={
                                                validacionByAseguradoraList.find(
                                                  (item) =>
                                                    item.idAseguradora ===
                                                    cotizacion
                                                      .aseguradoraEmpresa
                                                      .aseguradora.id
                                                )?.bloquearPlanes
                                              }
                                              subcoberturasParaExcluir={
                                                subcoberturasParaExcluir
                                              }
                                              controlFranquicias={
                                                controlFranquicias
                                              }
                                              alertaParaEjecutivo={
                                                alertaParaEjecutivo
                                              }
                                              comisionAseguradoraList={comisionAseguradoraList.filter(
                                                (item) =>
                                                  item.id_aseguradora ===
                                                  cotizacion.aseguradoraEmpresa
                                                    .aseguradora.id
                                              )}
                                              unaComision={unaComision}
                                            />
                                          )}
                                        </Fragment>
                                      );
                                    })}
                                  </>
                                );
                              })()}
                            </Space>
                          </div>
                        </div>
                      </Fragment>
                    )}
                    <br />
                  </Fragment>
                )}

                {screens && screens.md === false && (
                  <>
                    {cotizacion.planes && cotizacion.planes.length > 0 && (
                      <>
                        <div
                          style={{
                            display: 'center',
                            justifyContent: 'center',
                            alignItems: 'center'
                          }}
                        >
                          <LogoYTexto
                            logo={`/images/aseguradoras/${cotizacion.aseguradoraEmpresa.aseguradora.codigo}.png`}
                            texto={
                              cotizacion.aseguradoraEmpresa.aseguradora.nombre
                            }
                          />
                          <div
                            style={{
                              textAlign: 'left',
                              marginLeft: 0,
                              paddingLeft: 8
                            }}
                          >
                            {mostrarValidaciones && (
                              <>
                                {validacionByAseguradoraList.find(
                                  (item) =>
                                    item.idAseguradora ===
                                      cotizacion.aseguradoraEmpresa.aseguradora
                                        .id && item.mostrarAlerta
                                ) ? (
                                  <Space style={{ paddingBottom: 4 }}>
                                    <div style={{ textAlign: 'start' }}>
                                      <LabelValidateMessage
                                        message={
                                          validacionByAseguradoraList.find(
                                            (item) =>
                                              item.idAseguradora ===
                                              cotizacion.aseguradoraEmpresa
                                                .aseguradora.id
                                          ).mensaje
                                        }
                                        type="warning"
                                        hidden
                                      />
                                    </div>
                                    <div style={{ textAlign: 'start' }}>
                                      <Tooltip title="Los datos ingresados se encuentran fuera del rango permitido para esta Aseguradora. Por este motivo la solicitud quedará sujeta a autorización">
                                        <InfoCircleOutlined
                                          style={{ color: 'rgba(0,0,0,.45)' }}
                                        />
                                      </Tooltip>
                                    </div>
                                  </Space>
                                ) : (
                                  <Space style={{ paddingBottom: 4 }}>
                                    <div style={{ textAlign: 'start' }}>
                                      <LabelValidateMessage
                                        message={
                                          validacionByAseguradoraList.find(
                                            (item) =>
                                              item.idAseguradora ===
                                              cotizacion.aseguradoraEmpresa
                                                .aseguradora.id
                                          ).mensaje
                                        }
                                        type="secondary"
                                        hidden
                                      />
                                    </div>
                                  </Space>
                                )}
                              </>
                            )}
                          </div>
                          <div key={cotizacion.id}>
                            <div
                              style={{
                                textAlign: 'start'
                              }}
                            >
                              {(() => {
                                return (
                                  <>
                                    {monedaSelectedList.map((moneda) => {
                                      return (
                                        <Fragment key={moneda.id}>
                                          {esCliente ? (
                                            <SelectorPlanesMobileCliente
                                              {...{
                                                cotizacion,
                                                moneda,
                                                getSelectedCliente,
                                                onChange,
                                                opcionesDePago
                                              }}
                                              disabled={
                                                validacionByAseguradoraList.find(
                                                  (item) =>
                                                    item.idAseguradora ===
                                                    cotizacion
                                                      .aseguradoraEmpresa
                                                      .aseguradora.id
                                                ).bloquearPlanes
                                              }
                                              subcoberturasParaExcluir={
                                                subcoberturasParaExcluir
                                              }
                                              controlFranquicias={
                                                controlFranquicias
                                              }
                                              alertaParaEjecutivo={
                                                alertaParaEjecutivo
                                              }
                                              comisionAseguradoraList={comisionAseguradoraList.filter(
                                                (item) =>
                                                  item.id_aseguradora ===
                                                  cotizacion.aseguradoraEmpresa
                                                    .aseguradora.id
                                              )}
                                              comisionesAEPList={comisionesAEPList.filter(
                                                (item) =>
                                                  item.id_aseguradora_empresa_producto ===
                                                  cotizacion.id_aseguradora_empresa_producto
                                              )}
                                            />
                                          ) : (
                                            <SelectorPlanesMobile
                                              {...{
                                                cotizacion,
                                                moneda,
                                                getSelected,
                                                onChange,
                                                opcionesDePago
                                              }}
                                              disabled={
                                                validacionByAseguradoraList.find(
                                                  (item) =>
                                                    item.idAseguradora ===
                                                    cotizacion
                                                      .aseguradoraEmpresa
                                                      .aseguradora.id
                                                ).bloquearPlanes
                                              }
                                              subcoberturasParaExcluir={
                                                subcoberturasParaExcluir
                                              }
                                              controlFranquicias={
                                                controlFranquicias
                                              }
                                              alertaParaEjecutivo={
                                                alertaParaEjecutivo
                                              }
                                              comisionAseguradoraList={comisionAseguradoraList.filter(
                                                (item) =>
                                                  item.id_aseguradora ===
                                                  cotizacion.aseguradoraEmpresa
                                                    .aseguradora.id
                                              )}
                                              unaComision={unaComision}
                                            />
                                          )}
                                        </Fragment>
                                      );
                                    })}
                                  </>
                                );
                              })()}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}
              </Fragment>
            );
          })
        ) : (
          <div
            style={{
              height: 100

              // display: `${screens && screens.md === true && 'inline-block'}`
            }}
          >
            <Empty
              className="ant-empty-small"
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No hay planes que coincidan con los parámetros"
            />
          </div>
        )}
      </Spin>
    </div>
  );
};

export default GroupPlanSelectorMultiple;
